import { render } from "./SettingsCardWrapper.vue?vue&type=template&id=351ee98c&scoped=true"
import script from "./SettingsCardWrapper.vue?vue&type=script&lang=js"
export * from "./SettingsCardWrapper.vue?vue&type=script&lang=js"

import "./SettingsCardWrapper.vue?vue&type=style&index=0&id=351ee98c&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351ee98c"]])

export default __exports__